import { render } from "./FocusOnSelector.vue?vue&type=template&id=08182983"
import script from "./FocusOnSelector.vue?vue&type=script&lang=js"
export * from "./FocusOnSelector.vue?vue&type=script&lang=js"

import "./FocusOnSelector.vue?vue&type=style&index=0&id=08182983&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__